import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=861218d6&scoped=true&"
import script from "./Inventory.vue?vue&type=script&lang=ts&"
export * from "./Inventory.vue?vue&type=script&lang=ts&"
import style0 from "./Inventory.vue?vue&type=style&index=0&id=861218d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861218d6",
  null
  
)

export default component.exports